import React from 'react';
import PropTypes from 'prop-types';
import { Carousel } from '../../Generic/Carousel';
import RelatedArticle from '../RelatedArticles/RelatedArticles';
import styles from '../Article/article-tw-styles';

const settings = {
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  speed: 600,
  adaptiveHeight: false,
  infinite: false,
  lazyLoad: false,
  dots: true,
  draggable: true,
  autoplay: false,
  autoplaySpeed: 3000,
  prevArrow: <span className="glyphicon glyphicon-menu-left" />,
  nextArrow: <span className="glyphicon glyphicon-menu-right" />,
  responsive: [
    {
      breakpoint: 767,
      settings: {
        dots: true,
        draggable: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        autoplay: false,
        arrows: false,
        vertical: false,
        verticalSwipping: false,
      },
    },
    {
      breakpoint: 1023,
      settings: {
        dots: true,
        vertical: false,
        draggable: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
      },
    },
  ],
};

export default class ArticleCarousel extends React.PureComponent {
  constructor(props) {
    super(props);
  }
  render() {
    const { articleData } = this.props;
    return (
      <div className={styles.articleCarouselParent}>
        <Carousel {...settings} className={styles.articleCarouselCardWidth}>
          {articleData &&
            articleData.relatedArticlesCollection &&
            articleData.relatedArticlesCollection.items.map(articlepage => {
              return (
                <div
                  className={styles.articleRelatedProdDiv}
                  key={articlepage.sys.id}
                >
                  <RelatedArticle
                    key={articlepage.sys.id}
                    data={articlepage}
                  />
                </div>
              );
            })}
        </Carousel>
      </div>
    );
  }
}

ArticleCarousel.propTypes = {
  articleData: PropTypes.oneOfType([PropTypes.object]).isRequired,
  locale: PropTypes.string.isRequired,
};
